// action types for periods
export const SET_PERIODS_DATA = "SET_PERIODS_DATA";
export const ADD_PERIOD = "ADD_PERIOD";
export const UPDATE_PERIOD = "UPDATE_PERIOD";
export const DELETE_PERIOD = "DELETE_PERIOD";
